import React from 'react';
import { CampaignStyled } from '../styles';
import { CampaignTemplateProps } from '../../..';
import { UnacceptableValueException } from '@hiwaldo/sdk/exceptions';

export const CampaignTemplateCheckoutSmall = (props: CampaignTemplateProps) => {
  if (!props.checkoutSmall) {
    throw new UnacceptableValueException(
      'Could not load campaign checkout small template: Missing strapi content'
    );
  }

  const imageSrc = props.checkoutSmall?.attributes?.image?.data[0]?.attributes
    ?.url
    ? `${props.checkoutSmall.attributes.image.data[0].attributes.url}`
    : '';

  const imageAlt = props.checkoutSmall?.attributes?.image?.data[0]?.attributes
    ?.alternativeText
    ? props.checkoutSmall.attributes.image.data[0].attributes.alternativeText
    : props.checkoutSmall?.attributes?.image?.data[0]?.attributes?.name
    ? props.checkoutSmall.attributes.image.data[0].attributes.name
    : 'Campaign';

  return (
    <CampaignStyled
      data-cy="campaign-partial"
      id={props.id}
      className={props.classes}
    >
      <div className="campaign-image">
        <img src={imageSrc} alt={imageAlt} />
      </div>
      <div className="campaign-text">
        <div className="campaign-title">
          {props.checkoutSmall.attributes.title}
        </div>
        <div className="campaign-message">
          {props.checkoutSmall.attributes.code_message}
          <i>{props.checkoutSmall.attributes.legal}</i>
        </div>
      </div>
    </CampaignStyled>
  );
};
